import { render } from "./ContactTable.vue?vue&type=template&id=582c1a22"
import script from "./ContactTable.vue?vue&type=script&lang=js"
export * from "./ContactTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__